import React, { useEffect, useState } from "react"
import { Button, Card, Modal } from "react-bootstrap"
import { useTranslation } from "react-i18next"
import { clearDataDetailReport, getListDetailReport } from "../../../../redux/actions/AreaAction"
import { timeStampToDate, toMonthYear } from "../../../helpers/DateHelper"
import { stringFormatting } from "../../../helpers/TextHelper"
import { useDispatch, useSelector } from "react-redux"
import { DATE_TYPE_ENUM } from "../../../../constants/StringConstant"
import { Skeleton } from "@material-ui/lab"

const ModalListBA = ({ show, setShow, areaId }) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const { Area } = useSelector((state) => state)

  const [detailReport, setDetailReport] = useState([])

  useEffect(() => {
    return () => {
      setDetailReport([])
    }
  }, [])

  useEffect(() => {
    dispatch(getListDetailReport(areaId))
    return () => {
      dispatch(clearDataDetailReport())
    }
  }, [areaId])

  useEffect(() => {
    if (Area.detailReport) {
      setDetailReport(Area.detailReport)
    }
    return () => {
      setDetailReport([])
    }
  }, [Area.detailReport])

  return (
    <Modal
      show={show}
      onHide={() => setShow(false)}
      centered
      size="md"
      aria-labelledby="contained-modal-title-vcenter">
      <Modal.Header>
        <div className="text-uppercase font-weight-bolder txt-14">{t("label_list_ba")}</div>
      </Modal.Header>
      <Modal.Body>
        <div className="d-flex flex-column" style={{ gap: 24 }}>
          <div
            className="px-2 d-flex flex-column overflow-auto bg-white"
            style={{ maxHeight: 250, height: "100%", gap: 12 }}>
            {!detailReport.length && (
              <Skeleton animation="wave" variant={"text"} height={130} width={'100%'} />
            )}
            {detailReport.length ?
              detailReport?.map((item, i) => (
                <Card className="card-custom" bg={"secondary"} key={i}>
                  <Card.Body>
                    <div className="text-neutral-black txt-14">
                      <div className="d-flex justify-content-between align-items-center pb-2">
                        <div>
                          {`${toMonthYear(item?.planting_start_date)} - ${toMonthYear(
                            item?.planting_end_date
                          )}`}
                        </div>
                        <div className="d-flex align-items-center" style={{ gap: 12 }}>
                          <div>
                            {item?.submitted_date
                              ? timeStampToDate(item?.submitted_date, DATE_TYPE_ENUM.ISO_DATE_STRAP)
                              : "-"}
                          </div>
                        </div>
                      </div>
                      <div className="d-flex justify-content-between align-items-center">
                        <div className="d-flex align-items-center" style={{ gap: 12 }}>
                          <div className="txt-20 font-weight-bolder">
                            {stringFormatting(item?.status_label)}
                          </div>
                        </div>
                      </div>
                    </div>
                  </Card.Body>
                </Card>
              )): null}
          </div>
          <Button className={"btn btn-primary w-100 text-uppercase"} onClick={() => setShow(false)}>
            {t("button_oke")}
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  )
}

export default ModalListBA
